import React, { useEffect } from 'react'
import { gsap } from 'gsap/dist/gsap';
import Image from 'next/image';
import styles from './background.module.scss';

function BackgroundImage({data, moveBG, classes, bgcolor, position}) {
      // Animations
      useEffect(() => {  
        gsap.set('.section-bg', {scale: 1.4, opacity: 0});
        if(moveBG !== "no") {
          gsap.to('.section-bg', {scale:1.2, opacity: 1, ease:"power.out", duration: 1, delay:0 })
        } else {
          gsap.to('.section-bg', {scale:1, opacity: 1, ease:"power.out", duration: 1, delay:0 })
        }
          // Background Animation
          //console.log(moveBG);
        if(moveBG !== "no") {
          let container = document.querySelector('.body');
          container.addEventListener('mousemove', function(e) {
              parallaxIt(e, ".section-bg", -30);
              //parallaxIt(e, ".bg-mask1", -50);
          });
          
          function parallaxIt(e, target, movement) {
              var relX = e.pageX - container.offsetLeft;
              var relY = e.pageY - container.offsetTop;
          
              gsap.to(target, 1, {
                  x: (relX - container.offsetWidth / 2) / container.offsetWidth * movement,
                  y: (relY - container.offsetHeight / 2) / container.offsetHeight * movement
              });
          }
        }
  
      }, [moveBG]);
  return (
   <>
        <div 
        style={{backgroundColor: bgcolor}}
        className={`section-bg ${styles.sectionBG} ${position !== 'fixed' ? "absolute" : "fixed"} left-0 top-0 w-screen h-screen z-10 ${classes}`} >
            <Image 
                className='block object-cover object-center w-full h-full' 
                src={data?.bgImage?.src} 
                height={data?.bgImage?.height} 
                width={data?.bgImage?.width}
                blurDataURL={data?.bgImage?.blurDataURL}
                placeholder={'blur'}
                alt="Section BG" />
        </div>
   </>
  )
}

export default BackgroundImage